import {
  Box,
  Button,
  Grid2 as Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import dayjs from "configs/dayjs.config";

import { useGlobalContext } from "context/GlobalContext";
import { fetchUsersTaskApi } from "API/apis/admin/task/fetchUsersTask";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useUserTaskContext } from "../context";
import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { dateTimeFormat } from "constants/componentsConstants";

export const FilterSection = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [dateOption, setDateOption] = useState("TODAY");
  const [manualDateRange, setManualDateRange] = useState({
    startDate: dayjs(),
    endDate: dayjs(),
  });
  const [isManualDate, setIsManualDate] = useState(false);
  const { setIsLoading, setSuccess, setError } = useGlobalContext();

  const { setList, setReloadRequired, setSummary } = useUserTaskContext();
  const handleDateOptionChange = (e) => {
    const dateOption = e.target.value;
    setDateOption(dateOption);
    if (dateOption === "MANUAL") {
      setIsManualDate(true);
    } else if (dateOption === "TODAY") {
      setIsManualDate(false);
      setManualDateRange({
        startDate: dayjs(),
        endDate: dayjs(),
      });
    } else {
      setIsManualDate(false);
      setManualDateRange({
        startDate: dayjs().subtract(Number(dateOption), "months"),
        endDate: dayjs(),
      });
    }
  };

  const handleManualDateRange = (newValue, type) => {
    if (type === "START") {
      setManualDateRange({
        ...manualDateRange,
        startDate: dayjs(newValue).format(dateTimeFormat.date),
      });
    } else {
      setManualDateRange({
        ...manualDateRange,
        endDate: dayjs(newValue).format(dateTimeFormat.date),
      });
    }
  };

  const handleFilterClick = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const { data, status } = await fetchUsersTaskApi({
        startDate: new Date(
          dayjs(manualDateRange.startDate).format("YYYY-MM-DD")
        ),
        endDate: new Date(dayjs(manualDateRange.endDate).format("YYYY-MM-DD")),
        userId: selectedUser?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setList(data);
      setSuccess(data?.message);
      setIsLoading(false);
      setSummary({ deadlinePassed: 0, deadlineReached: 0, totalTasks: 0 });
      setReloadRequired(true);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <form onSubmit={handleFilterClick}>
      <Box p={3} border={1} borderRadius={2} borderColor="grey.300">
        <Grid container spacing={2}>
          {/* User Autocomplete */}
          <Grid container size={{ xs: 12, md: 4 }}>
            <FormControlWrapper fullWidth>
              <SearchUsers
                label="Select User"
                selectedUser={selectedUser}
                handleUserSelection={setSelectedUser}
                isRequired={true}
              />
            </FormControlWrapper>
          </Grid>
          {/* Date Selector */}
          <Grid container size={{ xs: 12, md: 2 }}>
            <FormControlWrapper fullWidth>
              <InputLabel id="date-option-label">Date Range</InputLabel>
              <Select
                labelId="date-option-label"
                value={dateOption}
                onChange={handleDateOptionChange}
                label="Date Range"
              >
                <MenuItem value="TODAY">Today</MenuItem>
                <MenuItem value="1">Last 30 Days</MenuItem>
                <MenuItem value="6">Last 6 Months</MenuItem>
                <MenuItem value="MANUAL">Manual</MenuItem>
              </Select>
            </FormControlWrapper>
          </Grid>

          {isManualDate && (
            <Grid container size={{ xs: 12, md: 4 }}>
              <Grid container size={{ xs: 12, md: 6 }}>
                <DatePickerWrapper
                  label="Start Date"
                  value={dayjs(manualDateRange.startDate)}
                  onChange={(newValue) =>
                    handleManualDateRange(dayjs(newValue), "START")
                  }
                  format="DD-MM-YYYY"
                  maxDate={dayjs()}
                />
              </Grid>
              <Grid container size={{ xs: 12, md: 6 }}>
                <DatePickerWrapper
                  label="End Date"
                  value={dayjs(manualDateRange.endDate)}
                  onChange={(newValue) =>
                    handleManualDateRange(dayjs(newValue), "END")
                  }
                  minDate={dayjs(manualDateRange.startDate).subtract(1, "days")}
                  maxDate={dayjs()}
                />
              </Grid>
            </Grid>
          )}

          {/* Filter Button */}
          <Grid container size={{ xs: 12, md: 1 }}>
            <Button size="large" fullWidth type="submit">
              Filter
            </Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};
